// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const FIN_ST_SOL_ADT = {
  Pendente: 'FIN_ST_SOL_ADT1',
  Aprovado: 'FIN_ST_SOL_ADT2',
  Cancelado: 'FIN_ST_SOL_ADT3',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    FIN_ST_SOL_ADT1: 9999,
    FIN_ST_SOL_ADT2: 9999,
    FIN_ST_SOL_ADT3: 9999
  }
}
